import React from 'react';

const TREND_UP   = { color:'var(--green)', icon:'↑' };
const TREND_DOWN = { color:'var(--red)',   icon:'↓' };
const TREND_FLAT = { color:'var(--text3)', icon:'→' };

export default function StatCard({
  label, value, sub, icon, color = 'var(--accent)',
  trend, trendLabel, loading = false, size = 'md', onClick,
}) {
  const trendStyle = trend > 0 ? TREND_UP : trend < 0 ? TREND_DOWN : TREND_FLAT;
  const isLg = size === 'lg';

  return (
    <div
      onClick={onClick}
      style={{
        background: 'var(--surface)',
        border: `1px solid var(--border)`,
        borderRadius: 'var(--r)',
        padding: isLg ? '24px 28px' : '18px 20px',
        position: 'relative',
        overflow: 'hidden',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'border-color 0.15s, box-shadow 0.15s',
      }}
      onMouseEnter={e => { if (onClick) { e.currentTarget.style.borderColor = color; e.currentTarget.style.boxShadow = `0 0 0 1px ${color}22`; }}}
      onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.boxShadow = 'none'; }}
    >
      {/* accent bar */}
      <div style={{ position:'absolute', top:0, left:0, right:0, height:3, background:color, opacity:0.8 }} />

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ fontSize:11, textTransform:'uppercase', letterSpacing:'0.08em', color:'var(--text3)', fontFamily:'var(--font-display)', marginBottom:8 }}>
            {label}
          </div>
          {loading ? (
            <div style={{ width:80, height:isLg?36:28, background:'var(--bg3)', borderRadius:4, animation:'pulse 1.5s infinite' }} />
          ) : (
            <div style={{ fontSize:isLg?38:28, fontFamily:'var(--font-display)', fontWeight:800, color:'var(--text)', lineHeight:1 }}>
              {value ?? '—'}
            </div>
          )}
          {!loading && sub && (
            <div style={{ fontSize:12, color:'var(--text3)', marginTop:6 }}>{sub}</div>
          )}
          {!loading && trend !== undefined && trend !== null && (
            <div style={{ fontSize:12, color:trendStyle.color, marginTop:6, fontWeight:600 }}>
              {trendStyle.icon} %{Math.abs(trend)} {trendLabel || ''}
            </div>
          )}
        </div>
        {icon && (
          <div style={{ fontSize:isLg?32:24, opacity:0.15, flexShrink:0, marginLeft:12 }}>{icon}</div>
        )}
      </div>
    </div>
  );
}
